/*=========================================================================================
  File Name: moduleNotificationsActions.js
  Description: Notifications Module Actions
==========================================================================================*/

import notifications_gql from "../../http/requests/link/notifications_gql";
import router from "@/router";
import { PAGES_PATH } from "../../utils/route";
import { NOTIFICATION } from "../../utils/constant";

export default {
	/**
	 * Get notifications by page
	 * @param {*} param0
	 * @param {*} payload
	 */
	fetchNotifications({ commit }, payload) {
		return new Promise((resolve, reject) => {
			notifications_gql
				.fetchNotifications(payload)
				.then(response => {
					if (response.notifications) {
						commit("SET_TOTAL_NOTIFICATIONS", response.notifications.total);
						commit("SET_NOTIFICATIONS", response.notifications.data);
						resolve(response);
					} else {
						reject(response);
					}
				})
				.catch(error => {
					reject(error);
				});
		});
	},
	fetchLatestNotifications({ commit }, payload) {
		return new Promise((resolve, reject) => {
			notifications_gql
				.fetchNotifications(payload)
				.then(response => {
					commit("SET_TOTAL_NOTIFICATIONS", response.notifications.total);
					commit("SET_LATEST_NOTIFICATIONS", response.notifications.data);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},
	fetchUnreadNotifications({ commit }) {
		return new Promise((resolve, reject) => {
			notifications_gql
				.fetchUnreadNotifications()
				.then(response => {
					commit("SET_UNREAD_NOTIFICATIONS", response.unread_notifications);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	/**
	 * Đánh dấu notifications đã đọc, dựa trên mảng id notification
	 * @param {*} param0
	 * @param {*} payload
	 */
	markAllReadNotifications({ state, dispatch }, payload) {
		return new Promise((resolve, reject) => {
			notifications_gql
				.markReadNotifications({ listIds: payload.listIds })
				.then(response => {
					dispatch("fetchNotifications", { limit: state.limitPerPage, page: payload.page });
					dispatch("fetchUnreadNotifications");
					dispatch("fetchLatestNotifications", { limit: state.limitLatest, page: 1 });
					resolve(response.read_notification);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	/**
	 * Xoá notifications dựa trên mảng id notification
	 * @param {*} param0
	 * @param {*} payload
	 */
	deleteNotifications({ commit }, payload) {
		return new Promise((resolve, reject) => {
			notifications_gql
				.deleteNotifications({ listIds: payload.listIds })
				.then(response => {
					commit("DELETE_NOTIFICATIONS", payload.listIds);
					resolve(response.delete_notifications);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	/**
	 * Click on a notification, mark it readed and redirect to detail base on the type.
	 * @param {*} param0
	 * @param {*} payload
	 */
	onClickNotification({ dispatch }, payload) {
		return new Promise(() => {
			if (!payload.notification) return;
			const listIds = [payload.notification.id];
			dispatch("markAllReadNotifications", { listIds }).then(() => {
				dispatch("redirectToDetailNotification", payload);
			});
		});
	},

	redirectToDetailNotification(store, payload) {
		const _options = payload.notification.options;
		const currentRoute = router.history && router.history.current;
		let query;
		if (_options.type === NOTIFICATION.TYPE.REQUEST) {
			const requestId = _options.data.params ? _options.data.params.request.id : _options.data.id;
			query = (currentRoute && currentRoute.path === PAGES_PATH.PAGE_CBS_REQUEST_PATH && currentRoute.query) || {};
			router.push({
				path: PAGES_PATH.PAGE_CBS_REQUEST_PATH,
				query: { ...query, id: requestId }
			});
		} else if (_options.type === NOTIFICATION.TYPE.DEVICE) {
			query = (currentRoute && currentRoute.path === PAGES_PATH.PAGE_CBS_DEVICE_PATH && currentRoute.query) || {};
			router.push({
				path: PAGES_PATH.PAGE_CBS_DEVICE_PATH,
				query: { ...query, id: _options.device.id }
			});
		} else if (_options.type === NOTIFICATION.TYPE.TODOLIST) {
			query = (currentRoute && currentRoute.path === PAGES_PATH.PAGE_CBS_TODO_PATH && currentRoute.query) || {};
			router.push({
				path: PAGES_PATH.PAGE_CBS_TODO_PATH,
				query: { ...query, id: _options.data.id }
			});
		} else if (_options.type === NOTIFICATION.TYPE.POST) {
			router.push({
				path: PAGES_PATH.PAGE_CBS_POST_PATH
			});
		} else if (_options.type === NOTIFICATION.TYPE.ALARMSG) {
			query = (currentRoute && currentRoute.path === PAGES_PATH.PAGE_CBS_ALARM_PATH && currentRoute.query) || {};
			router.push({
				path: PAGES_PATH.PAGE_CBS_ALARM_PATH,
				query: { ...query, id: _options.data.id }
			});
		}
	}
};
